import React, {useEffect, useState} from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import {numberFormatter} from "app/utils/stringUtil";
import {HighchartsOptionsUtil} from "app/utils/highchartsOptionsUtil";
import CountUp from "react-countup";
import {DashboardModuleProps} from "app/model/db/dashboardModuleProps";
import DashboardCard from "../modules/DashboardCard";
import {PpaRqsService} from "../../../services/rp/PpaRqsService";
import {ResponseResultCode} from "../../../model/response-api";

const defaultThrPPAOption: Highcharts.Options = {
  chart: {
    type: 'pie',
    height: 270,
    spacing: [20, 0, 0, 0],
    margin: [0, 0, 35, 0],
  },
  colors: ['#545CC1', '#4C96F9'],
  legend: {
    floating: true,
    layout: 'horizontal',
    verticalAlign: 'bottom',
    y: -24,
    padding: 0,
    borderWidth: 0,
    symbolHeight: 0,
    symbolPadding: 0,
    itemDistance: 0,
    useHTML: true,
    labelFormatter(this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-size:.8rem;font-weight:500;">${this.name}&nbsp;</span>
          <span style="font-size:.8rem;font-weight:700;">${numberFormatter(this.y)}건</span>
        </div>
      `;
    }
  },
  subtitle: {
    align: 'center',
    verticalAlign: 'middle',
    useHTML: true,
    y: -15,
    text: `
      <div style="text-align: center;">
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0건</span><br/>
        <span style="color: #444; font-size: 1rem; font-weight: 700; margin-top: .2rem; display: inline-block;">제3자PPA</span>
      </div>
      `,
  },
  tooltip: {
    useHTML: true,
    formatter: function (this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-weight:500;">${this.key}:&nbsp;</span>
          <span style="font-weight:700;">${numberFormatter(this.y)}</span> 건
          (<span style="font-weight:500;">${numberFormatter(this.percentage, 2)}%</span>)
        </div>
      `;
    }
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      innerSize: "72%",
      size: "85%",
      borderWidth: 0.5,
      borderRadius: 0,
    },
    series: {
      showInLegend: true,
      borderWidth: 0,
      dataLabels: {
        enabled: false,
      },
    },
  },
  responsive: {
    rules: [{
      condition: {maxWidth: 200},
      chartOptions: {
        chart: {spacingTop: 20},
        subtitle: {
          align: 'center',
          verticalAlign: 'middle',
          useHTML: true,
          y: -15,
          text: `
            <div style="text-align: center;">
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0</span><br/>
              <span style="color: #444; font-size: 1rem; font-weight: 700;">제3자PPA</span>
            </div>
          `,
        },
        tooltip: {enabled: false}
      }
    }]
  }
};

const defaultDrcPpaOption: Highcharts.Options = {
  chart: {
    type: 'pie',
    height: 270,
    spacing: [20, 0, 0, 0],
    margin: [0, 0, 35, 0],
  },
  colors: ['#44C5DB', '#9F92FF'],
  legend: {
    floating: true,
    layout: 'horizontal',
    verticalAlign: 'bottom',
    y: -24,
    padding: 0,
    borderWidth: 0,
    symbolHeight: 0,
    symbolPadding: 0,
    itemDistance: 0,
    useHTML: true,
    labelFormatter(this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-size:.8rem;font-weight:500;">${this.name}&nbsp;</span>
          <span style="font-size:.8rem;font-weight:700;">${numberFormatter(this.y)}건</span>
        </div>
      `;
    }
  },
  subtitle: {
    align: 'center',
    verticalAlign: 'middle',
    useHTML: true,
    y: -15,
    text: `
      <div style="text-align: center;">
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0건</span><br/>
        <span style="color: #444; font-size: 1rem; font-weight: 700; margin-top: .2rem; display: inline-block;">직접PPA</span>
      </div>
      `,
  },
  tooltip: {
    useHTML: true,
    formatter: function (this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-weight:500;">${this.key}:&nbsp;</span>
          <span style="font-weight:700;">${numberFormatter(this.y)}</span> 건
          (<span style="font-weight:500;">${numberFormatter(this.percentage, 2)}%</span>)
        </div>
      `;
    }
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      innerSize: "72%",
      size: "85%",
      borderWidth: 1,
      borderRadius: 0,
    },
    series: {
      showInLegend: true,
      borderWidth: 0,
      dataLabels: {
        enabled: false,
      },
    },
  },
  responsive: {
    rules: [{
      condition: {maxWidth: 200},
      chartOptions: {
        chart: {spacingTop: 20},
        subtitle: {
          align: 'center',
          verticalAlign: 'middle',
          useHTML: true,
          y: -15,
          text: `
            <div style="text-align: center;">
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0</span><br/>
              <span style="color: #444; font-size: 1rem; font-weight: 700;">직접PPA</span>
            </div>
          `,
        },
        tooltip: {enabled: false}
      }
    }]
  }
};

export default function BrokerTrdPrcnd(props: Readonly<DashboardModuleProps>) {
  Highcharts.setOptions({
    ...HighchartsOptionsUtil.locale.kr.globalOptions,
    title: {text: ""},
    exporting: {enabled: false},
    credits: {enabled: false},
    tooltip: {shared: true, headerFormat: ''},
    accessibility: {enabled: false},
  });

  const [drawChartA, setDrawChartA] = useState<any>(defaultThrPPAOption);
  const [drawChartB, setDrawChartB] = useState<any>(defaultDrcPpaOption);
  const [thrYearlySply, setThrYearlySply] = useState<number>(0);
  const [drcYearlySply, setDrcYearlySply] = useState<number>(0);

  function makeSubtitle(total: number, type: string) {
    return {
      align: 'center',
      verticalAlign: 'middle',
      useHTML: true,
      y: -15,
      text: `
        <div style="text-align: center;">
          <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span>
          <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">
            ${numberFormatter(total)}건
          </span><br/>
          <span style="color: #444; font-size: 1rem; font-weight: 700; margin-top:.1rem; display: inline-block;">
            ${type}
          </span>
        </div>
      `,
    };
  }

  function getPPATrdCnt() {
    PpaRqsService.getInstance().getCntrPwplCount()
    .then((response) => {
          if (response && ResponseResultCode.Y === response.resultCode) {
            const count = response.data.reduce((acc, value) => {
              if (value.emksCntrPrgsStsCd === 2) {
                if (value.drcPpaUseYn === "Y") acc["drcPpaWriting"]++;
                if (value.thdptPpaUseYn === "Y") acc["thdprPpaWriting"]++;
              }
              if (value.emksCntrPrgsStsCd === 5) {
                if (value.drcPpaUseYn === "Y") {
                  acc["drcPpaCompleted"]++;
                  acc["drcYearlySply"] += value.yyExpcSplyQnt;
                }
                if (value.thdptPpaUseYn === "Y")
                {
                  acc["thdptPpaCompleted"]++;
                  acc["thrYearlySply"] += value.yyExpcSplyQnt;
                }
              }
              return acc;
            }, {drcPpaCompleted: 0, drcPpaWriting: 0, drcYearlySply:0, thdptPpaCompleted: 0, thdprPpaWriting: 0, thrYearlySply:0});

            setDrawChartA({
              ...defaultThrPPAOption,
              subtitle: makeSubtitle(count.thdptPpaCompleted + count.thdprPpaWriting, '제3자PPA'),
              series: [{
                type: 'pie',
                name: '제3자PPA',
                data: convertToChartData(count.thdptPpaCompleted, count.thdprPpaWriting),
              }],
              plotOptions:{
                pie:{
                  borderWidth:convertToChartData(count.thdptPpaCompleted, count.thdprPpaWriting)?.every((item:any)=>item.y===0) ? 0.5 : 0,
                }
              }
            });
            setDrawChartB({
              ...defaultDrcPpaOption,
              subtitle: makeSubtitle(count.drcPpaCompleted + count.drcPpaWriting, '직접PPA'),
              series: [{
                type: 'pie',
                name: '직접PPA',
                data: convertToChartData(count.drcPpaCompleted, count.drcPpaWriting),
              }],
              plotOptions:{
                pie:{
                  borderWidth:convertToChartData(count.drcPpaCompleted, count.drcPpaWriting)?.every((item:any)=>item.y===0) ? 0.5 : 0,
                }
              }
            });
            setThrYearlySply(count.thrYearlySply);
            setDrcYearlySply(count.drcYearlySply)
          }
        }
    )
  };


  function convertToChartData(dataComplete: number, dataWriting: number) {
      return [{
        name: '완료', y: dataComplete ?? 0,
      }, {
        name: '진행', y: dataWriting ?? 0,
      }];
  }

  useEffect(() => {
    getPPATrdCnt();
  }, []);

  return (
      <DashboardCard
          title="거래 현황"
          isConfigMode={props.isConfigMode ?? false}
          moreButtonVisible={true}
          moreButtonUrl="/rp/cntrlist"
          dashboardConfig={props.dashboardConfig}
      >
        <div style={{display: "flex", flexWrap: 'wrap',}}>
          <div className="col-6">
            <div className="graph-area">
              <div className="chart">
                {drawChartA && (
                    <HighchartsReact highcharts={Highcharts} options={drawChartA}/>
                )}
              </div>
            </div>
            <div className="box-solo">
              <div className="inner">
                <p className="mgb5">연간 보장공급량</p>
                <strong className="c-num">
                  <CountUp end={thrYearlySply ?? 0} duration={0.5}>
                    {({countUpRef}) => <em ref={countUpRef}/>}
                  </CountUp>kWh
                </strong>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="graph-area">
              <div className="chart">
                {drawChartB && (
                    <HighchartsReact highcharts={Highcharts} options={drawChartB}/>
                )}
              </div>
            </div>
            <div className="box-solo">
              <div className="inner">
                <p className="mgb5">연간 보장공급량</p>
                <strong className="c-num">
                  <CountUp end={drcYearlySply ?? 0} duration={0.5}>
                    {({countUpRef}) => <em ref={countUpRef}/>}
                  </CountUp>MWh
                </strong>
              </div>
            </div>
          </div>
        </div>
      </DashboardCard>
  );
}
